// extracted by mini-css-extract-plugin
export var paginationContainer = "_1p-0";